export const iconFontAwesomeCommunicationEnvelope = (
	<i className="fa-solid fa-envelope"></i>
);
